import React from 'react';
import { MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
export const ThemeToggle = () => {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="relative p-2.5 rounded-full text-text-muted hover:text-primary transition-all duration-300 hover:bg-surface border border-transparent hover:border-border group overflow-hidden" aria-label="Toggle theme" data-id="element-188">
      <div className="relative z-10" data-id="element-189">
        {theme === 'light' ? <MoonIcon className="w-5 h-5 transition-transform duration-500 group-hover:-rotate-12" data-id="element-190" /> : <SunIcon className="w-5 h-5 transition-transform duration-500 group-hover:rotate-45" data-id="element-191" />}
      </div>
      <div className="absolute inset-0 bg-primary/5 scale-0 group-hover:scale-100 transition-transform duration-300 rounded-full" data-id="element-192" />
    </button>;
};